<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/83/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            为深入贯彻落实习近平总书记关于“要加强产业工人队伍建设，加快建设一支宏大的知识型、技能型、创新型产业工人大军”的重要指示，着眼打造“技能双流”人才高地，做强高质量建设中国航空经济之都技能人才支撑。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/83/title-1.png" alt="" />
                    <div class="content">
                        来双创业和发展的“大国工匠”认定为II类人才，国家级“技能大师工作室”“首席技师工作室”“劳模和工匠人才创新工作室”领衔人认定为III类人才。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/83/title-2.png" alt="" />
                    <div class="content">
                        参照《成都市双流区空港科创人力资源协同创新政策措施》，被认定为II类人才的“大国工匠”和被认定为III类人才的国家级“技能大师工作室”“首席技师工作室”“劳模和工匠人才创新工作室”领衔人分别享受下列人才服务保障支持。
                    </div>
                </div>
                <div class="sscl">
                    <img class="top" src="./../assets/imgs/83/title-3.png" alt="" />
                    <div class="content">
                        <div class="des" style="font-weight: normal; font-size: 0.26rem">
                            <div class="title">一. 购房支持</div>
                            <div>
                                ⑴类：双流区企事业单位引进顶尖高级技能人才，对符合成都市商品房限购政策相关规定，购房不受户籍和社保缴纳年限限制；
                            </div>
                            <div>
                                ⑵类：双流区确认的《成都市急需紧缺人才和高端人才目录》中A、B、C、D类人才，选择在双流区范围内购买人才公寓（含集中修建人才公寓和商品房配建人才公寓），按照《双流区人才公寓租售管理实施细则》规定，保障面积部分可享受购房款15%的政策性优惠。
                            </div>
                        </div>
                        <div class="des" style="
                                    font-weight: normal;
                                    font-size: 0.26rem;
                                    text-align: center;
                                ">
                            <div class="title">二. 安家支持</div>
                            享受一次性2.4万元安家补贴。
                        </div>
                        <div class="des" style="font-weight: normal; font-size: 0.26rem">
                            <div class="title" style="width: 4.25rem">
                                三. “悦航都”人才服务
                            </div>
                            享受每人每年2.4万元标准的人才服务，服务事项涵盖机场VIP出行、人才专车、健康体检、有机蔬菜配送、学习培训等。
                        </div>
                        <div class="des" style="font-weight: normal; font-size: 0.26rem">
                            <div class="title">四.子女教育支持</div>
                            家庭子女不受户籍及居住地限制，在我区范围内可一次性选择任一公办义务教育阶段学校及公办、普惠性民办幼儿园就读。
                        </div>
                        <div class="des" style="font-weight: normal; font-size: 0.26rem">
                            <div class="title">五.人才荣誉奖励</div>
                            对入选“空港创新人才奖”“空港卓越人才奖”“空港杰出人才奖”“航都人才友谊奖”的人才，分别给予5万元、4万元、3万元、2万元一次性奖励，并享受“悦航都”生活服务。
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/79/title-4.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                领衔人向相关受理单位申报
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                受理单位初审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                公示
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                受理单位复审
                            </div>
                            <div class="item">
                                <div class="dot">5</div>
                                兑现支持政策
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/78/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold">
                        及时受理。
                    </div>
                </div>
                <div class="sscl">
                    <img class="top" src="./../assets/imgs/83/title-6.png" alt="" />
                    <div class="content">
                        <div style="font-size: 0.34rem; font-weight: bold">
                            <span class="hollow-cricle"></span>（一）购房支持
                        </div>
                        <div class="des" style="margin-top: 0.3rem">
                            <div class="number" style="padding-left: 1.5rem">
                                <span class="label">咨询电话：</span>
                                <div>
                                    <a href="tel:028-85805996">028-85805996</a>
                                </div>
                            </div>
                            <div class="unit">
                                <span class="label">责任单位：</span>
                                区住建交通局住保科
                            </div>
                        </div>
                        <div style="
                                    font-size: 0.34rem;
                                    font-weight: bold;
                                    margin-top: 0.3rem;
                                ">
                            <span class="hollow-cricle"></span> （二）安家支持
                        </div>
                        <div class="des" style="margin-top: 0.3rem">
                            <div class="number" style="padding-left: 1.5rem">
                                <span class="label">咨询电话：</span>
                                <div>
                                    <a href="tel:028-85736261">028-85736261</a>
                                </div>
                            </div>
                            <div class="unit">
                                <span class="label">责任单位：</span>
                                区就业局培训科
                            </div>
                        </div>
                        <div style="
                                    font-size: 0.34rem;
                                    font-weight: bold;
                                    margin-top: 0.3rem;
                                ">
                            <span class="hollow-cricle"></span>（三）“悦航都”人才服务
                        </div>
                        <div class="des" style="margin-top: 0.3rem">
                            <div class="number" style="padding-left: 1.5rem">
                                <span class="label">咨询电话：</span>
                                <div>
                                    <a href="tel:028-85811323">028-85811323</a>
                                </div>
                            </div>
                            <div class="unit">
                                <span class="label">责任单位：</span>
                                区人社局人才服务中心高层次人才服务科
                            </div>
                        </div>
                        <div style="
                                    font-size: 0.34rem;
                                    font-weight: bold;
                                    margin-top: 0.3rem;
                                ">
                            <span class="hollow-cricle"></span>（四）子女教育支持
                        </div>
                        <div class="des" style="margin-top: 0.3rem">
                            <div class="number" style="padding-left: 2.5rem">
                                <span class="label">区教育局普教科：</span>
                                <div>
                                    <a href="tel:028-85805996">028-85830810</a>
                                </div>
                            </div>
                            <div class="number" style="padding-left: 2.5rem">
                                <span class="label">区教育局学前科：</span>
                                <div>
                                    <a href="tel:028-61481796">028-61481796</a>
                                </div>
                            </div>
                        </div>
                        <div style="
                                    font-size: 0.34rem;
                                    font-weight: bold;
                                    margin-top: 0.3rem;
                                ">
                            <span class="hollow-cricle"></span>（五）人才荣誉奖励
                        </div>
                        <div class="des" style="margin-top: 0.3rem">
                            <div class="number" style="padding-left: 1.5rem">
                                <span class="label">咨询电话：</span>
                                <div>
                                    <a href="tel:028-85815009">028-85815009</a>
                                </div>
                            </div>
                            <div class="unit">
                                <span class="label">责任单位：</span>
                                区委组织部人才科
                            </div>
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/83/code.png" />
                    <img class="text" src="../assets/imgs/83/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.77rem;
    }

    .technological-process {
        transform: translateY(-1.8rem);

        .sscl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    font-weight: bold;
                    font-size: 0.3rem;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }

                    .number {
                        box-sizing: border-box;
                        padding-left: 2.1rem;
                        position: relative;
                        line-height: 0.35rem;
                    }

                    .unit {
                        margin-top: 0.15rem;
                        box-sizing: border-box;
                        padding-left: 1.5rem;
                        position: relative;
                        line-height: 0.35rem;
                    }

                    .label {
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                }
            }
        }

        .zcjj {

            // background-color:#fff;
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;

                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: center;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                font-size: 0.32rem;
                font-weight: bold;
                color: #3d5aa3;

                .des {
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    padding-top: 0.1rem;
                    margin-top: 0.2rem;
                    position: relative;

                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4rem;
            }
        }
    }
}
</style>
